import React from 'react';
import PropTypes from 'prop-types';
import { ShellRecoverySurface } from '../ShellRecoverySurface';

/**
 * AuthRecoveryPage — self-hosted shell auth recovery surface.
 *
 * Rendered at /embedded/register when the shell bootstrap sequence reaches
 * needs_auth_recovery (CREDENTIALS_MISSING / GATEWAY_SESSION_UNAVAILABLE)
 * and silent registration also fails.
 *
 * Uses the shared ShellRecoverySurface with the auth_recovery variant.
 * The Retry link navigates to /embedded/app to restart the bootstrap sequence.
 */
const AuthRecoveryPage = ({ location }) => {
  const errorCode = new URLSearchParams(location.search || '').get('code');
  return <ShellRecoverySurface variant="auth_recovery" errorCode={errorCode} />;
};

AuthRecoveryPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

AuthRecoveryPage.defaultProps = {
  location: { search: '' },
};

export default AuthRecoveryPage;
